export default __webpack_public_path__ + "static/media/Dune-hd-8.7e56adc6.jpg";